import React from "react";
import { InteractiveTextLink } from "./interactive-text-link";

interface ClearAllLinkProps {
    label: string;
    className: string;
    onClear: () => void;
}

export const ClearAllLink: React.FC<ClearAllLinkProps> = ({
    label,
    className,
    onClear,
}) => (
    <InteractiveTextLink className={className} onClick={onClear}>
        {label}
    </InteractiveTextLink>
);
